import { useState } from 'react';
import Navbar from '../homepage/navbar/Navbar';
import Footer from '../homepage/footer/Footer';
import { handleAPIRequest } from '../../api/api';
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const formData = new FormData();
        formData.append("email", email);
        try {
            const response = await handleAPIRequest('post','forgot-password',formData);
            toast.success(response.message);
        } catch (error) {
            toast.error(error || 'Something went wrong');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex flex-col min-h-screen">
            {/* Navbar at the top */}
            <Navbar />

            {/* Main content centered */}
            <div className="flex flex-1 items-center justify-center bg-gradient-to-br from-blue-500 to-teal-400 p-4">
                <div className="bg-white/90 shadow-xl rounded-lg p-6 md:p-8 w-full max-w-md backdrop-blur-lg">
                    <h2 className="text-2xl font-semibold text-gray-800 text-center mb-4">Forgot Password</h2>
                    <p className="text-gray-600 text-center mb-6">Enter your email to receive a password reset link</p>

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            required
                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:outline-none transition duration-200"
                        />
                        <button
                            type="submit"
                            className="w-full bg-blue-500 text-white py-2 rounded-md font-semibold hover:bg-blue-600 transition duration-200 flex items-center justify-center"
                            disabled={loading}
                        >
                            {loading ? 'Sending...' : 'Send Reset Link'}
                        </button>
                    </form>
                </div>
            </div>

         
            <Footer />
            <ToastContainer/>
        </div>
    );
};

export default ForgotPassword;
